import { render, staticRenderFns } from "./IconMastercard.vue?vue&type=template&id=ce980508&"
import script from "./IconMastercard.vue?vue&type=script&lang=js&"
export * from "./IconMastercard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports